import { useAppDispatch } from '@App/hooks'
import { CloseIcon } from '@App/static/icons/ArrowIcons'

import { IRemoveAlertModalData } from '@Redux/slices/modals/interfaces'
import {sendDeletePriceAlert} from "@Redux/slices/sockets/ProxyServiceConnectionSlice";

import { Button } from '@UI/crypto_exchange/desktop/components/controls/Button'

import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

export const RemoveAlertModal = ({ isOpen, setIsOpen, ids }: ModalTypes & IRemoveAlertModalData) => {
  const dispatch = useAppDispatch()

  const confirm = () => {
    ids.forEach((id) => {
      dispatch(sendDeletePriceAlert({
        uuid: id
      }))
    })
    setIsOpen()
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container}>
        <div className={s.header}>
          <h3>{`${ids.length > 1 ? 'Remove all active alerts?' : 'Remove this alert?'}`}</h3>

          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.modalControl}>
          <Button size="small" variant="outlined" onClick={setIsOpen}>
            Cancel
          </Button>
          <Button className={s.removeBtn} size="small" onClick={confirm}>
            {`${ids.length > 1 ? 'Remove all' : 'Remove'}`}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
